import { useTickets } from 'contexts/TicketsContext';

type UseScheduleListViewHeaderT = {
  handleCloseScheduleListView: () => void;
};

function useScheduleListViewHeader(): UseScheduleListViewHeaderT {
  const { setIsScheduleTicketList } = useTickets();

  const handleCloseScheduleListView = (): void => {
    setIsScheduleTicketList(false);
  };

  return {
    handleCloseScheduleListView,
  };
}

export default useScheduleListViewHeader;
